import { Dialog, AppBar, Toolbar, Typography, Button, DialogContent, Grid, TextField, DialogActions, FormControlLabel, Switch } from "@mui/material"
import { useState, useRef, useEffect } from "react"
import { useLimitacaoConsumoService } from "../../../../../use-cases/limitacao-consumo"
import { useNavigationService } from "../../../../../use-cases/navigation"
import { useUIService } from "../../../../../use-cases/ui"
import { onlyNumbers } from "../../../../../utils"
import { useAppSelector } from "../../../../hooks/store-hooks"
import { ITipoUsuario } from "../../../../../application/models"
import CloseIcon from '@mui/icons-material/Close'

export const FormUpdateTravaConsumoCliente = () => {
    const { updateLimitacaoConsumoClienteForm } = useAppSelector((state) => state.limitacaoConsumo)
    const { currentUser } = useAppSelector((state) => state.user)
    const [loading, setLoading] = useState<boolean>(true)
    const isFirstRender = useRef(false)
    const isDemais = currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_DEMAIS
    const isTecnologiaDaInformacao = currentUser?.IdVelesPerfilInterno === ITipoUsuario.TECNOLOGIA_DA_INFORMACAO
    const isCliente = currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_CLIENTE
    const canEdit = isDemais || isTecnologiaDaInformacao || isCliente
    const {
        setUpdateLimitacaoConsumoClienteOpenForm,
        setUpdateLimitacaoConsumoClienteFormQuantidade,
        updateLimitacaoConsumoCliente,
        setUpdateLimitacaoConsumoClienteFormAtivo
    } = useLimitacaoConsumoService()
    const { setAlert } = useUIService()
    const { navigateTo } = useNavigationService()
    
    useEffect(() => {
        if (!isFirstRender.current) {
            setLoading(false)
            isFirstRender.current = true

            const { IdLimitacaoConsumoCliente, IdGrupoTrava } = updateLimitacaoConsumoClienteForm.fields
            const hasValidId = (IdLimitacaoConsumoCliente && IdLimitacaoConsumoCliente > 0) || (IdGrupoTrava && IdGrupoTrava > 0)

            if (!hasValidId) {
                navigateTo({
                    route: '/dashboard/trava/consumo'
                })
            }
        }
    }, [updateLimitacaoConsumoClienteForm.fields, navigateTo, setAlert])
    // Function
    const handleClose = () => {
        setUpdateLimitacaoConsumoClienteOpenForm({
            open: false
        })
    }

    return (
        loading ? <></>
            : <>
                <Dialog
                    open={true}
                    fullScreen
                    disableEscapeKeyDown
                    onClose={handleClose}
                    scroll={'paper'}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <Typography sx={{ ml: 2, flex: 1 }} textTransform={"uppercase"} fontWeight={"bold"} variant="h6" component="div">
                                {canEdit ? 'Atualizar trava de consumo' : 'Visualizar trava de consumo'}
                            </Typography>
                            <Button
                                color="inherit"
                                startIcon={<CloseIcon />}
                                onClick={handleClose}
                                aria-label="close"
                            >
                                Fechar
                            </Button>
                        </Toolbar>
                    </AppBar>
                    <DialogContent dividers={true}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={8}>
                                <TextField
                                    value={
                                        updateLimitacaoConsumoClienteForm.fields.Quantidade === 0 ? ''
                                            : updateLimitacaoConsumoClienteForm.fields.Quantidade.toLocaleString('pt-BR')
                                    }
                                    onChange={(e) => {
                                        setUpdateLimitacaoConsumoClienteFormQuantidade({
                                            Quantidade: Number(onlyNumbers(e.target.value))
                                        })
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    error={Boolean(updateLimitacaoConsumoClienteForm.touched && updateLimitacaoConsumoClienteForm.errors.find(item => item.key === 'Quantidade'))}
                                    helperText={updateLimitacaoConsumoClienteForm.errors.find(item => item.key === 'Quantidade')?.message}
                                    name="quantidade"
                                    fullWidth
                                    id="quantidade"
                                    label="Quantidade"
                                    autoFocus
                                    disabled={!canEdit}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <FormControlLabel
                                    label={updateLimitacaoConsumoClienteForm.fields.Ativo === true ? 'Trava de consumo ativa' : 'Trava de consumo inativa'}
                                    control={
                                        <Switch
                                            checked={updateLimitacaoConsumoClienteForm.fields.Ativo}
                                            onChange={(e) => {
                                                setUpdateLimitacaoConsumoClienteFormAtivo({
                                                    Ativo: e.target.checked
                                                })
                                            }}
                                            name="Ativo"
                                            color="primary"
                                            disabled={!canEdit}
                                        />
                                    }
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Fechar</Button>
                        {canEdit && (
                            <Button onClick={updateLimitacaoConsumoCliente} variant="contained">Atualizar trava de consumo</Button>
                        )}
                    </DialogActions>
                </Dialog>
            </>
    )
}